<template>
  <div class="container">
    <div class="content">
      <h2>🐱✨ Paws & Prosperity: Cash Flow Beyond the Basics 🐾🌟</h2>
      <p>Each of these fabulous options represents a stage in your financial journey. Which one resonates with you?</p>

      <div class="option" @click="selectOption('excellent')" :class="{ selected: isSelected('excellent') }">
        <span class="icon">🤑</span>
        <b>Rolling in Catnip: Income > Expenses?</b>
          Like a cat with an overflowing toy box, do your finances give you plenty to play with, and some extra to tuck away for a rainy day?
      </div>

      <div class="option" @click="selectOption('day-to-day')" :class="{ selected: isSelected('day-to-day') }">
        <span class="icon">😭</span>
        <b>Chasing Your Tail: Income = Expenses? </b> Are you always on the prowl, with every coin earned being immediately pawed away? Living moment to meow-ment?
      </div>

      <div class="option" @click="selectOption('confident')" :class="{ selected: isSelected('confident') }">
        <span class="icon">😸</span>
        <b>Catnap King/Queen: Sleeping without Money Worries?</b>
          Do you snuggle into your financial blanket every night, whiskers twitching in contentment, confident about your bank balance?
      </div>

      <div class="option" @click="selectOption('anxious')" :class="{ selected: isSelected('anxious') }">
        <span class="icon">🙀</span>
        <b>Hissing at Bills: Anxious for Arrivals?</b>
          Does the thought of bills make your tail puff up? Do you dread peeping at your account, fearing a game of hide and seek with your balance?
      </div>

    
    </div>
  </div><br><br><br><br><br><br>
</template>


<script>
import { onboardingStore } from '@/components/stores/onboardingStore'; // Adjust the path as necessary

export default {
  setup() {
    const store = onboardingStore();

    const selectOption = (option) => {
      // Set the selected option directly
      store.updateFormData({ cashflow_goals: option });
    };

    // Helper method to check if an option is selected
    const isSelected = (option) => store.formData.cashflow_goals === option;

    return { store, selectOption, isSelected };
  },
};
</script>





<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
background-color: white;
padding: 20px;
border-radius: 10px;
color: black;
}

.option {
padding: 10px;
border: 1px solid #ccc;
border-radius: 10px;
text-align: center;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
cursor: pointer;
transition: transform 0.3s ease, box-shadow 0.3s ease;
margin-bottom: 10px;
}

.option:hover {
transform: translateY(-5px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


.selected {
background-color: #4A148C; /* More solid color for selection */
color: white;
}


.icon {
font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>